import { avatarUrlBuilder } from "@common";
import { useSelector } from "react-redux";
import copyIcon from "../../assets/pictures/icons/copy-icon-white.svg";
import type { IRootState } from "../../redux/store";
import { copyToClipboard } from "../../utils/shared";
import styles from "./NotifyCopyLink.module.scss";
import linkImg from "../../assets/pictures/link-image.svg";
import { trackCopyLink } from "../../utils/analyticsTracker";

interface Props {
	handleCopyLink: () => void;
	link: string;
	onClose: () => void;
}

const NotifyCopyLink: React.FC<Props> = ({ handleCopyLink, link, onClose }) => {

	const handleClick = () => {
		handleCopyLink();
		trackCopyLink();
	};

	return (
		<div className={styles.content}>
			<button className={styles.buttonClose} type="button" onClick={onClose} />
			<img src={linkImg} alt="link" className={styles.linkImage} />
			<h2>Ссылка на проект с аватаром скопирована! </h2>
			<p>
				Откройте её прямо сейчас в новой вкладке<br /> или поделитесь с клиентами.
			</p>
			<div className={styles.linkContainer}>
				<span>{link}</span>
				<button
					type="button"
					onClick={handleClick}
					aria-label="Copy avatar link"
					className={styles.buttonCopy}
				>
					<img src={copyIcon} alt="copy" />
				</button>
			</div>
			<a
				className={styles.openLink}
				target="_blank"
				href={link}
				rel="noreferrer"
			>
				Открыть в новой вкладке
			</a>
		</div>
	);
};

export default NotifyCopyLink;
